// extracted by mini-css-extract-plugin
export default {"Login":"Login_Login__wjj8F","section":"Login_section__MnEXU","Button":"Login_Button__SRJ8l","Bottom":"Login_Bottom__AB0yv"};